/**
 * Billing address validation for Shopify Forms.
 * Supports the legacy single field (custom#adress) and native company
 * signup fields (billing_address_address1 + city / zip / country).
 * Uses Google Places Autocomplete + Geocoder / Address Validation
 * to confirm the value is a real street address.
 */
(function () {
  if (window.__loopFormsAddressValidationInit) return;
  window.__loopFormsAddressValidationInit = true;

  var ADDRESS_FIELD_SELECTOR = [
    '[data-testid="field-custom#adress"]',
    '[id="custom#adress"]',
    '[data-testid="field-billing_address_address1"]',
    '[id="billing_address_address1"]',
  ].join(', ');
  var STRUCTURED_ADDRESS_IDS = {
    billing_address_address1: true,
  };
  var ERROR_ID = 'loop-address-format-error';
  var STYLE_ID = 'loop-address-format-styles';
  var BOUND_ATTR = 'data-loop-address-bound';
  var VALIDATED_ATTR = 'data-loop-address-validated';
  // Copy comes from locales/en.default.json via sections/apps.liquid.
  var STRINGS = window.loopAddressStrings || {};
  var INVALID_MESSAGE =
    STRINGS.invalid ||
    'Enter a real street address and select it from the suggestions when possible.';
  var CHECKING_MESSAGE = STRINGS.checking || 'Checking address…';
  var POLL_MS = 400;
  var POLL_MAX_MS = 60000;
  var GOOGLE_KEY = 'AIzaSyDceBZiZl-Yex_J1JliEwtZbKBW6_wviko';

  function whenGoogleReady(callback) {
    if (window.google && google.maps && google.maps.places) {
      callback();
      return;
    }

    if (!document.getElementById('loop-google-maps-places')) {
      var script = document.createElement('script');
      script.id = 'loop-google-maps-places';
      script.src =
        'https://maps.googleapis.com/maps/api/js?libraries=places&v=weekly&key=' +
        encodeURIComponent(GOOGLE_KEY) +
        '&loading=async';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }

    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (window.google && google.maps && google.maps.places) {
        clearInterval(timer);
        callback();
      } else if (attempts > 80) {
        clearInterval(timer);
        console.warn('[loop-address] Google Maps failed to load');
      }
    }, 100);
  }

  function ensurePacStyles() {
    if (document.getElementById('loop-pac-container-styles')) return;
    var style = document.createElement('style');
    style.id = 'loop-pac-container-styles';
    style.textContent =
      '.pac-container{z-index:2147483647!important;pointer-events:auto;}' +
      '.pac-container[data-loop-pac-hidden="true"]{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;}';
    document.head.appendChild(style);
  }

  // Never remove .pac-container from the DOM — Google Places keeps an
  // internal reference and suggestions break for the rest of the session.
  function hidePacContainers() {
    document.querySelectorAll('.pac-container').forEach(function (el) {
      el.setAttribute('data-loop-pac-hidden', 'true');
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function showPacContainers() {
    document.querySelectorAll('.pac-container').forEach(function (el) {
      el.removeAttribute('data-loop-pac-hidden');
      el.style.removeProperty('display');
    });
  }

  function closePacDropdown() {
    hidePacContainers();
    setTimeout(hidePacContainers, 0);
    setTimeout(hidePacContainers, 50);
    setTimeout(hidePacContainers, 150);
  }

  function getFieldRoot(field) {
    var root = field && field.getRootNode && field.getRootNode();
    return root && root.querySelector ? root : document;
  }

  function isStructuredAddressField(field) {
    var id = (field && field.id) || '';
    var testid = (field && field.getAttribute('data-testid')) || '';
    return !!STRUCTURED_ADDRESS_IDS[id] || testid === 'field-billing_address_address1';
  }

  function queryRelatedField(root, id) {
    if (!root || !root.querySelector) return null;
    return root.querySelector('[id="' + id + '"], [data-testid="field-' + id + '"]');
  }

  function fieldValue(field) {
    return field && field.value ? field.value.trim() : '';
  }

  function countryLabel(root) {
    var node =
      (root && root.getElementById && root.getElementById('billing_address_country-selector-value')) ||
      (root && root.querySelector && root.querySelector('#billing_address_country-selector-value'));
    return node && node.textContent ? node.textContent.trim() : '';
  }

  function composeStructuredAddress(field) {
    var root = getFieldRoot(field);
    var parts = [
      fieldValue(field),
      fieldValue(queryRelatedField(root, 'billing_address_address2')),
      [fieldValue(queryRelatedField(root, 'billing_address_zip')), fieldValue(queryRelatedField(root, 'billing_address_city'))]
        .filter(Boolean)
        .join(' '),
      fieldValue(queryRelatedField(root, 'billing_address_province')),
      countryLabel(root),
    ].filter(Boolean);

    return parts.join(', ');
  }

  function getValidationAddress(field) {
    if (isStructuredAddressField(field)) return composeStructuredAddress(field);
    return fieldValue(field);
  }

  function componentMap(components) {
    var map = {};
    (components || []).forEach(function (component) {
      (component.types || []).forEach(function (type) {
        if (!map[type]) map[type] = component.long_name;
      });
    });
    return map;
  }

  function streetLineFromComponents(components) {
    var map = componentMap(components);
    var line = [map.street_number, map.route].filter(Boolean).join(' ').trim();
    return line || map.premise || '';
  }

  function setNativeInputValue(field, value) {
    if (!field || !value) return;
    if (field.value === value) return;
    field.value = value;
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function applyStructuredAddress(field, place) {
    if (!place || !place.address_components) return;

    var root = getFieldRoot(field);
    var map = componentMap(place.address_components);
    var street = streetLineFromComponents(place.address_components);
    var city = map.locality || map.postal_town || map.administrative_area_level_2;
    var zip = map.postal_code;

    if (street) setNativeInputValue(field, street);
    setNativeInputValue(queryRelatedField(root, 'billing_address_city'), city);
    setNativeInputValue(queryRelatedField(root, 'billing_address_zip'), zip);
  }

  function findAddressFields() {
    var fields = [];

    document.querySelectorAll('shopify-forms-embed').forEach(function (embed) {
      if (!embed.shadowRoot) return;
      var field = embed.shadowRoot.querySelector(ADDRESS_FIELD_SELECTOR);
      if (field) fields.push({ root: embed.shadowRoot, field: field });
    });

    document.querySelectorAll('[data-form-root="true"]').forEach(function (wrapper) {
      var embed = wrapper.querySelector('shopify-forms-embed');
      if (!embed || !embed.shadowRoot) return;
      var field = embed.shadowRoot.querySelector(ADDRESS_FIELD_SELECTOR);
      if (field) fields.push({ root: embed.shadowRoot, field: field });
    });

    return fields;
  }

  function ensureStyles(shadowRoot) {
    if (!shadowRoot) return;

    var style = shadowRoot.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      shadowRoot.appendChild(style);
    }

    style.textContent = [
      '[' + BOUND_ATTR + '="true"][aria-invalid="true"] {',
      '  box-shadow: 0 0 0 2px var(--form-error-color, #E02229) !important;',
      '}',
      '#' + ERROR_ID + ' {',
      '  color: var(--form-error-color, #E02229);',
      '  font: var(--forms-body-font, normal 400 14px Arial, sans-serif);',
      '  font-size: 12px;',
      '  line-height: 1.4;',
      '  margin: 6px 0 0;',
      '  text-align: left;',
      '}',
      '#' + ERROR_ID + '[hidden] {',
      '  display: none !important;',
      '}',
    ].join('\n');
  }

  function getErrorElement(field) {
    var container = field.closest('div') || field.parentElement;
    if (!container) return null;

    var existing = container.querySelector('#' + ERROR_ID);
    if (existing) return existing;

    var error = document.createElement('p');
    error.id = ERROR_ID;
    error.setAttribute('role', 'alert');
    error.hidden = true;
    container.appendChild(error);
    return error;
  }

  function setFieldError(field, message) {
    var error = getErrorElement(field);
    field.setAttribute('aria-invalid', 'true');
    field.setAttribute('aria-describedby', ERROR_ID);
    field.removeAttribute(VALIDATED_ATTR);

    if (error) {
      error.textContent = message;
      error.hidden = false;
    }
  }

  function clearFieldError(field) {
    var error = getErrorElement(field);
    field.setAttribute('aria-invalid', 'false');
    field.removeAttribute('aria-describedby');

    if (error) {
      error.textContent = '';
      error.hidden = true;
    }
  }

  function markValidated(field, formatted, options) {
    var opts = options || {};
    field.setAttribute(VALIDATED_ATTR, 'true');

    if (isStructuredAddressField(field)) {
      if (opts.place) applyStructuredAddress(field, opts.place);
    } else if (formatted && field.value !== formatted) {
      field.value = formatted;
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    }

    clearFieldError(field);
  }

  function hasStreetSignal(components) {
    if (!components || !components.length) return false;
    var types = {};
    components.forEach(function (component) {
      (component.types || []).forEach(function (type) {
        types[type] = true;
      });
    });
    return !!(
      types.street_number ||
      types.route ||
      types.premise ||
      types.subpremise
    );
  }

  function isPreciseGeocode(result) {
    if (!result) return false;
    var types = result.types || [];
    var preciseType = types.some(function (type) {
      return (
        type === 'street_address' ||
        type === 'premise' ||
        type === 'subpremise' ||
        type === 'route'
      );
    });
    var locationType =
      result.geometry && result.geometry.location_type
        ? result.geometry.location_type
        : '';
    var preciseLocation =
      locationType === 'ROOFTOP' ||
      locationType === 'RANGE_INTERPOLATED' ||
      locationType === 'GEOMETRIC_CENTER';

    return (
      (preciseType || preciseLocation) &&
      hasStreetSignal(result.address_components)
    );
  }

  function validateWithAddressValidationApi(address) {
    return fetch(
      'https://addressvalidation.googleapis.com/v1:validateAddress?key=' +
        encodeURIComponent(GOOGLE_KEY),
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          address: { addressLines: [address] },
        }),
      }
    )
      .then(function (response) {
        if (!response.ok) {
          return Promise.reject(new Error('address_validation_http_' + response.status));
        }
        return response.json();
      })
      .then(function (payload) {
        var result = payload.result || {};
        var verdict = result.verdict || {};
        var postalAddress =
          (result.address && result.address.postalAddress) || {};
        var formatted =
          (result.address && result.address.formattedAddress) ||
          (postalAddress.addressLines && postalAddress.addressLines.join(', ')) ||
          address;

        var ok =
          verdict.addressComplete === true ||
          verdict.validationGranularity === 'PREMISE' ||
          verdict.validationGranularity === 'SUB_PREMISE' ||
          verdict.validationGranularity === 'PREMISE_PROXIMITY';

        // Soften missing-complete flag when Google still returns a precise granularity.
        if (!ok && verdict.hasUnconfirmedComponents === false && verdict.validationGranularity) {
          ok =
            verdict.validationGranularity === 'PREMISE' ||
            verdict.validationGranularity === 'SUB_PREMISE' ||
            verdict.validationGranularity === 'ROUTE';
        }

        return { ok: !!ok, formatted: formatted, source: 'addressValidation' };
      });
  }

  function validateWithGeocoder(address) {
    return new Promise(function (resolve) {
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: address }, function (results, status) {
        if (status !== 'OK' || !results || !results.length) {
          resolve({ ok: false, source: 'geocoder' });
          return;
        }

        var match = results.find(isPreciseGeocode) || null;
        if (!match) {
          resolve({ ok: false, source: 'geocoder' });
          return;
        }

        resolve({
          ok: true,
          formatted: match.formatted_address || address,
          source: 'geocoder',
        });
      });
    });
  }

  function validateAddressValue(rawValue) {
    var value = (rawValue || '').trim();
    if (!value) {
      return Promise.resolve({ ok: false, empty: true });
    }

    if (value.length < 5) {
      return Promise.resolve({
        ok: false,
        empty: false,
        message: INVALID_MESSAGE,
      });
    }

    return validateWithAddressValidationApi(value)
      .catch(function () {
        return validateWithGeocoder(value);
      })
      .then(function (result) {
        if (result && result.ok) return result;
        return {
          ok: false,
          empty: false,
          message: INVALID_MESSAGE,
          result: result,
        };
      });
  }

  function validateField(field, options) {
    var opts = options || {};
    var streetValue = fieldValue(field);
    var value = getValidationAddress(field);

    if (!streetValue) {
      if (!opts.requireValue) {
        clearFieldError(field);
        return Promise.resolve(true);
      }
      setFieldError(field, INVALID_MESSAGE);
      return Promise.resolve(false);
    }

    if (field.getAttribute(VALIDATED_ATTR) === 'true' && !opts.force) {
      clearFieldError(field);
      return Promise.resolve(true);
    }

    setFieldError(field, CHECKING_MESSAGE);

    return validateAddressValue(value).then(function (validation) {
      if (validation.ok) {
        markValidated(field, validation.formatted || value);
        return true;
      }

      if (validation.empty && !opts.requireValue) {
        clearFieldError(field);
        return true;
      }

      setFieldError(field, validation.message || INVALID_MESSAGE);
      return false;
    });
  }

  function attachAutocomplete(field) {
    if (field.__loopPlacesAutocomplete) return;

    var autocomplete = new google.maps.places.Autocomplete(field, {
      fields: ['formatted_address', 'address_components', 'geometry'],
      types: ['address'],
    });

    field.__loopPlacesAutocomplete = autocomplete;

    // Enter selects a Places suggestion AND would submit the form —
    // which surfaces every Shopify Forms required-field error.
    field.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.keyCode === 13) {
        event.preventDefault();
        event.stopPropagation();
        setTimeout(closePacDropdown, 100);
        setTimeout(closePacDropdown, 250);
      }

      if (event.key === 'Escape' || event.keyCode === 27) {
        closePacDropdown();
      }
    });

    autocomplete.addListener('place_changed', function () {
      var place = autocomplete.getPlace();
      if (!place || !place.geometry) {
        field.removeAttribute(VALIDATED_ATTR);
        closePacDropdown();
        return;
      }

      var formatted = place.formatted_address || field.value;
      markValidated(field, formatted, { place: place });

      // Shadow-DOM inputs don't reliably close Google's body-level dropdown.
      closePacDropdown();
      setTimeout(function () {
        field.blur();
        closePacDropdown();
      }, 0);
    });
  }

  function bindField(shadowRoot, field) {
    if (field.getAttribute(BOUND_ATTR) === 'true') return;
    field.setAttribute(BOUND_ATTR, 'true');
    ensureStyles(shadowRoot);
    ensurePacStyles();
    attachAutocomplete(field);

    var validateTimer = null;

    field.addEventListener('focus', function () {
      showPacContainers();
    });

    field.addEventListener('input', function () {
      showPacContainers();
      field.removeAttribute(VALIDATED_ATTR);
      if (field.getAttribute('aria-invalid') === 'true') {
        clearFieldError(field);
      }
    });

    field.addEventListener('blur', function () {
      // Delay so a Places item click can complete before we hide .pac-container.
      clearTimeout(validateTimer);
      validateTimer = setTimeout(function () {
        closePacDropdown();
        validateField(field, { requireValue: false, force: true });
      }, 250);
    });
    var form = field.closest('form');
    if (!form || form.getAttribute(BOUND_ATTR + '-address') === 'true') return;

    form.setAttribute(BOUND_ATTR + '-address', 'true');

    var allowingSubmit = false;

    function currentAddressField() {
      return shadowRoot.querySelector
        ? shadowRoot.querySelector(ADDRESS_FIELD_SELECTOR)
        : null;
    }

    function blockIfInvalid(event) {
      if (allowingSubmit) return;

      var activeField = currentAddressField();
      if (!activeField) return;

      var value = (activeField.value || '').trim();
      if (!value) return;

      // Already confirmed via Places / prior validation — let Forms continue.
      if (activeField.getAttribute(VALIDATED_ATTR) === 'true') return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      validateField(activeField, { requireValue: true, force: true }).then(
        function (ok) {
          if (!ok) {
            activeField.focus();
            return;
          }

          allowingSubmit = true;
          try {
            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit();
            } else {
              HTMLFormElement.prototype.submit.call(form);
            }
          } finally {
            setTimeout(function () {
              allowingSubmit = false;
            }, 0);
          }
        }
      );
    }

    form.addEventListener('submit', blockIfInvalid, true);

    var submitButton = form.querySelector(
      '[data-testid="btn-form-submit"], button[type="submit"]'
    );
    if (submitButton) {
      submitButton.addEventListener('click', blockIfInvalid, true);
    }
  }

  function scan() {
    var found = findAddressFields();
    found.forEach(function (item) {
      bindField(item.root, item.field);
    });
    return found.length > 0;
  }

  function startObserving() {
    scan();

    var observer = new MutationObserver(function () {
      scan();
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    var startedAt = Date.now();
    var poll = setInterval(function () {
      var bound = scan();
      if (bound || Date.now() - startedAt > POLL_MAX_MS) {
        clearInterval(poll);
        if (bound) setInterval(scan, 2000);
      }
    }, POLL_MS);
  }

  whenGoogleReady(function () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startObserving);
    } else {
      startObserving();
    }
  });
})();
